import { Translate } from 'react-redux-i18n'
import { languages } from '../../../../../configs/language'
import { Element } from '../../../../common/html/element'
import { Radio } from '../../../../common/html/radio'

export const GroupRadioContract = ({ onChange, activeValue }) => {
  return (
    <div className="mb3 dFlex gap3">
      <Element
        className="fw600"
        style={{ marginBottom: 2, paddingLeft: 10, color: '#3A414B' }}
      >
        <Translate value="userManagement.contractInfo.LANGUAGE" />
      </Element>
      <Element className="dFlex gap2" style={{ color: '#3A414B' }}>
        <div>
          <Radio
            title="postLogin.VIETNAMESE"
            isI18n
            isCheckOnClickText
            activeValue={activeValue}
            value={languages.vi}
            onChange={onChange}
          />
        </div>
        <div>
          <Radio
            title="postLogin.ENGLISH"
            isI18n
            isCheckOnClickText
            activeValue={activeValue}
            value={languages.en}
            onChange={onChange}
          />
        </div>
      </Element>
    </div>
  )
}
